module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-b1ecede5eb9cea8d79579889641d0aa8.png";